/* global __OAUTH_ROOT_URL__, __API_ROOT_URL__, btoa */
import angular from 'angular';
import constants from 'app/constants';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';


let _$http;
let _upload;
let _utilityService;

class orgDataService {
  constructor(
    $http,
    Upload,
    utilityService // eslint-disable-line no-shadow
  ) {
    _$http = $http;
    _upload = Upload;
    _utilityService = utilityService;

    console.log('app.services.orgDataService created');
  }

  // //// Membership //////
  login(username, password, referenceCode) {
    const authorizationHeader = `Basic ${btoa(`${username}:${password}`)}`;

    return _$http({
      url: `${__OAUTH_ROOT_URL__}/token`,
      method: 'POST',
      headers: {
        Authorization: authorizationHeader,
        'Content-Type': 'application/x-www-form-urlencoded',
        Origin_Application: '1', // theSafe
      },
      data: _utilityService.serializeData({
        grant_type: 'password',
        username,
        password,
        client_id: 'Web_App',
        code: referenceCode
      }),
    });
  }

  loginByAzureAD(referenceCode, claim) {
    let _clientId = claim.email;
    if (!claim.email) {
      _clientId = claim.upn;
    }
    const clientSecret = btoa(JSON.stringify(claim));
    return _$http({
      url: `${__OAUTH_ROOT_URL__}/token`,
      method: 'POST',
      headers: {
        Authorization: 'code',
        'Content-Type': 'application/x-www-form-urlencoded',
        Origin_Application: '1', // theSafe
      },
      data: _utilityService.serializeData({
        grant_type: 'authorization_code',
        code: referenceCode,
        client_id: _clientId,
        client_secret: clientSecret,
      }),
    });
  }

  loginUser(userName, inviteAccepted) {
    // const authorizationHeader = `Basic ${btoa(`${username}:${password}`)}`;
    return _$http({
      url: `${__OAUTH_ROOT_URL__}/login`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      params: {
        userName,
        inviteAccepted
      },
    });
  }

  logout() {
    return _$http({
      url: `${__API_ROOT_URL__}/ui/logout`,
      method: 'POST',
    });
  }

  impersonate(userId) {
    return _$http({
      url: `${__OAUTH_ROOT_URL__}/impersonate`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: _utilityService.serializeData({
        userId
      }),
    });
  }

  resetImpersonation() {
    return _$http({
      url: `${__OAUTH_ROOT_URL__}/impersonate/reset`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: {},
    });
  }

  logUserAccess() {
    return _$http({
      url: `${__API_ROOT_URL__}/org/userAccess/`,
      method: 'POST',
      data: {},
      responseType: 'json',
      params: {
        echo: true,
      },
    });
  }

  getUserInfo() {
    return _$http({
      url: `${__API_ROOT_URL__}/ui/userInfo/1`,
      method: 'GET',
    });
  }

  getIsNavantaUser() {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/isNavantaUser`,
      method: 'GET',
    });
  }

  getUser() {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/`,
      method: 'GET',
    });
  }

  checkLoginNameExists(id, loginName) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/loginExists`,
      method: 'GET',
      params: {
        id,
        loginName,
      },
    });
  }

  getPortalInfo() {
    const dt = new Date();
    const ticks = ((dt.getTime() * 10000) + 6213559680);
    return _$http({
      url: `${__API_ROOT_URL__}/ui/portal/1?cb=${ticks}`,
      method: 'GET',
    });
  }

  getAssignedBanks(userId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/assigned?userId=${userId}`,
      method: 'GET',
    });
  }

  switchBanks(customerId) {
    return _$http({
      url: `${__OAUTH_ROOT_URL__}/switch/${customerId}`,
      method: 'PUT',
    });
  }

  getReleaseNotes() {
    return _$http({
      url: `${__API_ROOT_URL__}/service/release/active`,
      method: 'GET',
    });
  }

  getReleaseNoteItems() {
    return _$http({
      url: `${__API_ROOT_URL__}/ui/releaseNoteItem/ByProduct`,
      method: 'GET',
    });
  }

  saveUser(user) {
    let url = `${__API_ROOT_URL__}/org/user`;
    let method = 'POST';

    if (user.userId > 0) {
      url = `${__API_ROOT_URL__}/org/user/${user.userId}`;
      method = 'PUT';
    }

    return _$http({
      url,
      method,
      data: JSON.stringify(user),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  saveUserPreference(userId, name, value, echo) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/${userId}/preference/saveNameValue`,
      method: 'POST',
      data: _utilityService.serializeData({
        name,
        value,
        echo
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  logUserNavigation(userId, navigationId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/${userId}/navigation/${navigationId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  unlockUser(user) {
    const url = `${__API_ROOT_URL__}/org/user/unlockUser/${user.userId}`;
    const method = 'PUT';

    return _$http({
      url,
      method,
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  // //// Azure //////
  sendAzureInvite(user) {
    let _url = '';
    if (!user.lastInvitationSentDate) {
      _url = `${__API_ROOT_URL__}/org/user/azureinvitation/${user.userId}`;
    } else {
      _url = `${__API_ROOT_URL__}/org/user/resendazureinvitation/${user.userId}`;
    }
    return _$http({
      url: _url,
      method: 'PUT',
      data: {},
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  loginNameExist() {
    return _$http({
      url: `${__API_ROOT_URL__}/service/release/active`,
      method: 'GET',
    });
  }

  activateAzureAD(customerId) {
    const _url = `${__API_ROOT_URL__}/org/customer/activateAzure`;
    return _$http({
      url: _url,
      method: 'PUT',
      data: {},
      params: {
        echo: true,
        customerId
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  allowAzureUser(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/allowAzureUser`,
      method: 'GET',
      params: {
        echo: true,
        customerId
      },
    });
  }

  // //// Customers //////
  getActiveCustomers() {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer`,
      method: 'GET',
    });
  }

  getCurrentCustomer() {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/current`,
      method: 'GET',
    });
  }

  getCustomer(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/${customerId}`,
      method: 'GET',
    });
  }

  getCustomerWithLogo(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/${customerId}?includeLogo=true`,
      method: 'GET',
    });
  }

  getVisibleCustomers(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/visible/`,
      method: 'GET',
      params: {
        customerId,
      },
    });
  }

  saveCustomer(customer) {
    if (customer.customerId > 0) {
      return _$http({
        url: `${__API_ROOT_URL__}/org/customer/${customer.customerId}`,
        method: 'PUT',
        data: _utilityService.serializeData(customer),
        params: { echo: true },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer`,
      method: 'POST',
      data: _utilityService.serializeData(customer),
      params: { echo: true },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getCustomerAccess(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/${customerId}/customeraccess`,
      method: 'GET',
    });
  }

  getCustomerServices(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/${customerId}/services`,
      method: 'GET',
    });
  }

  saveCustomerService(customerService) {
    if (customerService.customerServiceId > 0) {
      return _$http({
        url: `${__API_ROOT_URL__}/org/customerService/${customerService.customerServiceId}`,
        method: 'PUT',
        data: _utilityService.serializeData(customerService),
        params: { echo: true },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return _$http({
      url: `${__API_ROOT_URL__}/org/customerService/`,
      method: 'POST',
      data: _utilityService.serializeData(customerService),
      params: { echo: true },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getServices() {
    return _$http({
      url: `${__API_ROOT_URL__}/org/service`,
      method: 'GET',
    });
  }

  getServicesForUser() {
    return _$http({
      url: `${__API_ROOT_URL__}/org/service/byUser`,
      method: 'GET',
    });
  }

  // //// Service Acceptance //////
  getCSAText(serviceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/service/${serviceId}/eula/byService`,
      method: 'GET',
    });
  }

  isCSARequired(customerId, serviceId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/service/${serviceId}/eula/isRequired`,
      method: 'GET',
      params: {
        customerId,
        serviceId,
      },
    });
  }

  getEULAServiceAcceptanceByCustomer(customerId, serviceEulaId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/serviceEulaAcceptance/byCustomerServiceEula`,
      method: 'GET',
      params: {
        customerId,
        serviceEulaId,
      },
    });
  }

  acceptCSA(serviceEulaAcceptance) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/serviceEulaAcceptance`,
      method: 'POST',
      data: JSON.stringify(serviceEulaAcceptance),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  // //// Users //////
  syncUsers(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/${customerId}/syncUsers`,
      method: 'PUT',
      data: {},
      responseType: 'json',
      params: {
        echo: true,
      },
    });
  }

  getApplicationUsers() {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/application`,
      method: 'GET',
      params: {}
    });
  }

  getSelectableUsers() {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/selectable`,
      method: 'GET',
      params: {}
    });
  }

  // //// Customer Logo //////
  downloadCustomerLogo(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/${customerId}`,
      method: 'GET',
      params: {
        id: customerId,
        includeLogo: true,
      },
    });
  }

  deleteCustomerLogo(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/logo/${customerId}`,
      method: 'DELETE',
    });
  }

  saveCustomerLogo(customerId, file) {
    const url = `${__API_ROOT_URL__}/org/customer/saveLogo`;
    return _upload.upload({
      url,
      method: 'POST',
      data: {
        echo: true,
        customerId,
        file,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // Customer handlers
  getUserAdministrationActions(custId) {
    return _$http({
      url: `${this.userHandlerDirectory}getUserAdministrationActions.ashx`,
      method: 'GET',
      params: {
        id: custId,
      },
    });
  }

  // User functions
  getUserPreference(name) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/userPreference/byName`,
      method: 'GET',
      params: {
        name,
      },
    });
  }

  getUsersByCustomerId(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/byCustomer`,
      method: 'GET',
      params: {
        customerId,
      },
    });
  }

  updateUser(user) {
    if (user.userId > 0) {
      return _$http({
        url: `${__API_ROOT_URL__}/org/user/${user.userId}`,
        method: 'PUT',
        data: JSON.stringify(user),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/json' },
      });
    }
    return _$http({
      url: `${__API_ROOT_URL__}/org/user`,
      method: 'POST',
      data: JSON.stringify(user),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  fixUser(userId) {
    return _$http({
      url: this.userHandlerUrl,
      method: 'POST',
      params: {
        command: 'FixUser',
        userId,
      },
    });
  }

  deleteUser(userId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/${userId}?echo=true`,
      method: 'DELETE',
    });
  }

  // User Import Functions
  stageUserImportData(fileName, customerId, bankName, uploadType) {
    return _$http({
      url: `${this.userImportHandlerDirectory}stageImportData.ashx`,
      method: 'POST',
      params: {
        fileName,
        bankName,
        customerId,
        uploadType,
      },
    });
  }

  processUserDataImport(userImportSetId) {
    return _$http({
      url: `${this.userImportHandlerDirectory}processImport.ashx`,
      method: 'POST',
      params: {
        userImportSetID: userImportSetId,
      },
    });
  }

  getUserImportDetails(userImportSetId) {
    return _$http({
      url: `${this.userImportHandlerDirectory}getImportDetails.ashx`,
      method: 'GET',
      params: {
        userImportSetID: userImportSetId,
      },
    });
  }

  getReportRecipients() {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/customerReportRecipients`,
      method: 'GET',
      params: {
      },
    });
  }

  // User Customers

  getUserCustomerAssignments(userId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customer/assigned`,
      method: 'GET',
      params: {
        userId,
      },
    });
  }

  saveUserCustomerAssignments(userId, customerIds) {
    const data = {
      userId,
      customerIds,
      echo: true,
    };
    return _$http({
      url: `${__API_ROOT_URL__}/org/userCustomer/saveBulk`,
      method: 'POST',
      data: _utilityService.serializeData(data),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // Role functions
  getRoles(applicationId, customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/role/${applicationId}/byCustomer?customerId=${customerId}`,
      method: 'GET',
      // params: {
      //   customerId: customerId,
      // },
    });
  }

  getUserRoles(userId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/${userId}/role/byUser`,
      method: 'GET',
      params: {
        userId,
      },
    });
  }

  assignUserRoles(userId, assignedRoles) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/user/${userId}/role`,
      method: 'POST',
      data: {
        userId,
        roles: assignedRoles
      },
      responseType: 'json',
      params: {
        echo: true,
      },
    });
  }

  // Customer Data
  resetCustomerVMData(customerId, emailSuffix) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customerData/resetVendorManagement/${customerId}?emailSuffix=${emailSuffix}`,
      method: 'PUT',
    });
  }

  deleteCustomerVMData(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customerData/deleteVendorManagement/${customerId}`,
      method: 'DELETE',
    });
  }

  getCustomerDomains(customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/customerDomain/${customerId}`,
      method: 'GET',
      // params: {
      //   customerId: customerId,
      // },
    });
  }

  // Utility
  checkDateValidity(date) {
    return _$http({
      url: this.ajaxManagerHandlerUrl,
      method: 'GET',
      data: {
        action: 'checkDateValidity',
        date,
      },
      responseType: 'text',
    });
  }

  checkPastDate(date) {
    return _$http({
      url: this.ajaxManagerHandlerUrl,
      method: 'GET',
      data: {
        action: 'checkPastDate',
        date,
      },
      responseType: 'text',
    });
  }

  checkDateGreaterThan(date, compareDate) {
    return _$http({
      url: this.ajaxManagerHandlerUrl,
      method: 'GET',
      data: {
        action: 'checkDateGreaterThan',
        date,
        compareDate,
      },
      responseType: 'text',
    });
  }

  // State (location) functions
  getStates() {
    return _$http({
      url: `${__API_ROOT_URL__}/admin/state`,
      method: 'GET',
    });
  }

  // Province (location) functions
  getProvinces() {
    return _$http({
      url: `${__API_ROOT_URL__}/admin/province`,
      method: 'GET',
    });
  }

  downloadDocument(documentId) {
    return _$http({
      url: `${__API_ROOT_URL__}/media/document/${documentId}`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  downloadDocumentContent(documentId, customerId) {
    return _$http({
      url: `${__API_ROOT_URL__}/media/document/content/${customerId}/${documentId}`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  checkVendorAlertRecipientEmail(vendorId, alertRecipientId, email) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/alertRecipient/exists/email`,
      method: 'GET',
      params: {
        vendorId,
        id: alertRecipientId,
        email,
      },
    });
  }

  saveAlertRecipient(alertRecipient) {
    if (alertRecipient.alertRecipientId > 0) {
      return _$http({
        url: `${__API_ROOT_URL__}/org/alertRecipient/${alertRecipient.alertRecipientId}`,
        method: 'PUT',
        data: _utilityService.serializeData(alertRecipient),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return _$http({
      url: `${__API_ROOT_URL__}/org/alertRecipient`,
      method: 'POST',
      data: _utilityService.serializeData(alertRecipient),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteAlertRecipient(alertRecipientId) {
    return _$http({
      url: `${__API_ROOT_URL__}/org/alertRecipient/${alertRecipientId}`,
      method: 'DELETE',
    });
  }

  getUserNotifications() {
    return _$http({
      url: `${__API_ROOT_URL__}/notification/user`,
      method: 'GET',
    });
  }

  getSystemNotifications() {
    return _$http({
      url: `${__API_ROOT_URL__}/notification/system/byUser`,
      method: 'GET',
    });
  }

  dismissSystemNotification(systemNotificationId) {
    return _$http({
      url: `${__API_ROOT_URL__}/notification/system/${systemNotificationId}/dismiss`,
      method: 'PUT',
      data: {},
      responseType: 'json',
      params: {
        echo: true,
      },
    });
  }

  getApplicationsNotifications() {
    return _$http({
      url: `${__API_ROOT_URL__}/notification/application/byUser`,
      method: 'GET',
    });
  }

  dismissApplicationNotification(applicationNotificationId) {
    return _$http({
      url: `${__API_ROOT_URL__}/notification/application/${applicationNotificationId}/dismiss`,
      method: 'PUT',
      data: {},
      responseType: 'json',
      params: {
        echo: true,
      },
    });
  }

  dismissApplicationAllNotifications(applicationNotificationIds) {
    return _$http({
      url: `${__API_ROOT_URL__}/notification/application/dismissAllNotifications`,
      method: 'PUT',
      data: JSON.stringify(applicationNotificationIds),
      responseType: 'json',
      params: {
        echo: true,
      },
    });
  }

  getWidgets() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/widget`,
      method: 'GET',
    });
  }

  getWidget(widgetId) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/widget/${widgetId}`,
      method: 'GET',
    });
  }

  saveWidgetPreference() {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/WidgetUserPreference/saveBulk`,
      method: 'POST',
    });
  }

  saveBulkWidgetPreferences(widgetUserPreferences) {
    return _$http({
      url: `${__API_ROOT_URL__}/ent/WidgetUserPreference/saveBulk`,
      method: 'POST',
      data: widgetUserPreferences,
      responseType: 'json',
    });
  }
}

orgDataService.$inject = [
  '$http',
  'Upload',
  'utilityService'
];

export default angular.module('app.services.orgDataService', [
  ngFileUpload,
  constants
])
  .service('orgDataService', orgDataService)
  .name;
